module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-RegularItalic.37666aee.woff2";